export const LargeAdvScheduleGifsUrl =
  'https://lc2spaces.atl1.cdn.digitaloceanspaces.com/LC2-FAQ/LeoCloudAdvScheduleStepGifFiles/largeDeviceGifs/';
export const SmallAdvScheduleGifsUrl =
  'https://lc2spaces.atl1.cdn.digitaloceanspaces.com/LC2-FAQ/LeoCloudAdvScheduleStepGifFiles/smallDeviceGifs/';
